import { Checkbox } from '@sb1/ffe-form-react';
import styles from './opt-in-personalized-newsletter-check.module.less';

export const OptInPersonalizedNewsletterCheck = ({
    consentedToPersonalizedNewsletter,
    personalizedNewsletterOnChange,
}) => {
    return (
        <div className={styles.smallCheckWrapper}>
            <Checkbox
                inline={false}
                checked={consentedToPersonalizedNewsletter}
                onChange={() => personalizedNewsletterOnChange(!consentedToPersonalizedNewsletter)}
            >
                Jeg ønsker månedlige e-poster med personaliserte tips til andre fine spleiser jeg kan støtte
            </Checkbox>
        </div>
    );
};
